// extracted by mini-css-extract-plugin
export default {"bottomNav":"BottomNav_bottomNav__obXia","item":"BottomNav_item__TZSTp","active":"BottomNav_active__McWi8","label":"BottomNav_label__xujNZ","hidden":"BottomNav_hidden__hj95o"};